import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../redux/commonSlice";
import {  createZippedMedia} from "../../../services/api";

import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import useSnackMessage from "../../../hooks/useSnackMessage";

export default ()=> {
    const dispatch = useDispatch();
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const mediaFilesReducer = useSelector((state) => state.mediaFilesReducer);
    const payload = {event_id: mediaFilesReducer.imported_project_id ,current_event_id: commonReducer.production_event_id}

    const [createZippedMediaStatus, setCreateZippedMediaStatus] = useState('')
    const [downloadZippedMediaID, setDownloadZippedMediaId] = useState(null)
    const [showSnackbar] = useSnackMessage();
 

   //POST API Request to  to send seleceted media files to create download link
   const { mutate: createZippedMediaMutate, isLoading: createZippedMediaLoading } =
   useMutation(createZippedMedia, {
     onSuccess: (response, variables, context) =>
       createZippedMediaSuccessHandler(response, variables, context),
     onError: (error, variables, context) =>
       createZippedMediaErrorHandler(error, variables, context),
   });

   useEffect(() => {
     if(createZippedMediaLoading == true){
        setCreateZippedMediaStatus('loading')
     }
   }, [createZippedMediaLoading])
   


 const createZippedMediaSuccessHandler =  (response, variables, context) => {
   const responseObject = response?.data;
   const responseData = responseObject?.data
   if (responseObject?.http_code == 200) {
    // showSnackbar(responseObject);
     //console.log(responseData.zipped_file_id)
     setDownloadZippedMediaId(responseData.zipped_file_id)
     setCreateZippedMediaStatus("success");
    //  setEnableDownload(true)
   }
 };

 const createZippedMediaErrorHandler = (error, variables, context) => {
   setCreateZippedMediaStatus("error");
   const errorObject = error?.response?.data;
   showSnackbar(errorObject)
   //console.log(errorObject)
 };




return [createZippedMediaMutate, createZippedMediaStatus , downloadZippedMediaID]

}